import React from 'react';
import Pagination from "react-js-pagination";
import styled from "styled-components";

const PaginationCustom = ({paged}) => {
    const handlePageChange = (number) => paged.setPageable((page) => ({
        ...page,
        page: number-1
    }));

    return(
        <div className={"paginationBox"}>
            <Pagination
                        activePage={paged.pageable.page + 1}
                        itemsCountPerPage={paged.pageable.size}
                        totalItemsCount={paged.pageable.totalElements}
                        pageRangeDisplayed={7}
                        onChange={handlePageChange}
                        prevPageText={"이전"}
                        nextPageText={"다음"}
            />
        </div>
    )
}

export default PaginationCustom;